(function(){
  var PROMOS = window.NNA_PROMOS || [];
  if (!PROMOS.length || !window.fetch) return;
  var PROP = 'Promotion';
  var origFetch = window.fetch.bind(window);
  var busy = false, timer = null;
  function isFree(item){ return item.properties && item.properties[PROP]; }
  function post(url, body){ return origFetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();}); }
  async function sync(){
    if (busy) return false; busy = true; var changed = false;
    try {
      var cart = await origFetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
      for (var i=0;i<PROMOS.length;i++){
        var p = PROMOS[i];
        var lines = cart.items.filter(function(it){ return it.variant_id === p.variant; });
        var paid = 0, free = [], freeQty = 0;
        lines.forEach(function(it){ if (isFree(it)) { free.push(it); freeQty += it.quantity; } else { paid += it.quantity; } });
        var want = p.free * Math.floor(paid / p.buy);
        if (freeQty === want && free.length <= 1) continue;
        for (var k=1;k<free.length;k++){ await post('/cart/change.js',{id:free[k].key,quantity:0}); }
        if (free.length) { await post('/cart/change.js',{id:free[0].key,quantity:want}); }
        else if (want > 0) { var props = {}; props[PROP] = p.label; await post('/cart/add.js',{items:[{id:p.variant,quantity:want,properties:props}]}); }
        changed = true;
      }
    } catch(e) { console.warn('NNA promo sync', e); }
    busy = false;
    return changed;
  }
  function refresh(){ try { sessionStorage.setItem('nnaPromoReload', String(Date.now())); } catch(e){} location.reload(); }
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function(){ clearTimeout(timer); timer = setTimeout(function(){ sync().then(function(c){ if (c) refresh(); }); }, 350); });
    }
    return p;
  };
  document.addEventListener('DOMContentLoaded', function(){
    sync().then(function(c){
      var last = 0; try { last = +sessionStorage.getItem('nnaPromoReload') || 0; } catch(e){}
      if (c && Date.now() - last > 5000) refresh();
    });
  });
})();